import {environment} from "../../../../src/environments/environment";

/**
 * Адреса сторінки SignWidget, яку завантажує iframe. Залежить від стенду
 * (environment.signWidgetUrl):
 *
 * - dev/local - тестовий віджет АТ "ІІТ" (eu.iit.com.ua). Його whitelist
 *   пропускає будь-який origin з іменем `localhost` (порт значення не має),
 *   тож локальна розробка працює без реєстрації домену. Віддає тестовий
 *   список ЦСК (CAs.Test.All.json) і тестові сервери хмарного підпису.
 * - qa/prod - бойовий віджет id.gov.ua. Його whitelist суворий: origin має
 *   бути зареєстрований в IIT, `localhost` там НЕ дозволений.
 *
 * Обидві сторінки - той самий білд віджета (однаковий протокол обміну і
 * однаковий формат відповіді ReadPrivateKey), різняться лише конфігурацією
 * ЦСК та whitelist.
 */
export const SIGN_WIDGET_URI: string = environment.signWidgetUrl;

/**
 * Шлях до клієнтської бібліотеки віджета. Завантажується ліниво, при першому
 * відкритті вікна зчитування ключа.
 */
export const SIGN_WIDGET_SCRIPT_SRC = "assets/eusign.js";

/**
 * Діагностичне логування відповіді віджета на ReadPrivateKey(), а також усіх
 * "сирих" postMessage від iframe (dah-key-widget.component.ts::listenRawMessages) -
 * для пошуку недокументованих подій віджета (наприклад про внутрішній лоадер).
 *
 * Склад полів у відповіді не задекларований у бібліотеці IIT. Структуру звірено
 * з реальним ключем (КНЕДП ДПС) і зафіксовано в eusign-widget.types.ts, тож
 * лог за замовчанням вимкнено - вмикати лише для розбору проблем з іншим ЦСК
 * або для дебагу протоколу віджета. У консоль потрапляють дані сертифіката
 * (ФІО, коди), тому НЕ вмикати на qa/prod.
 */
export const SIGN_WIDGET_DEBUG = false;

/**
 * Пропускає перевірку співпадіння коду компанії (ЄДРПОУ юр. особи чи
 * РНОКПП фіз. особи, action.erdpou) з кодом зчитаного ключа сертифіката
 * (subjEDRPOUCode/subjDRFOCode) - і в DahKeyWidgetComponent.validateCertificates(),
 * і в централізованій DahSignWorkerService.hashSign(). Дозволяє підписати
 * будь-яким тестовим ключем локально, без потреби мати ключ саме тієї
 * юр./фіз. особи, що зазначена в документі.
 *
 * Інші перевірки (ключ уже заблокований, той самий ключ і для директора,
 * і для печатки, повторний підпис тим самим ключем) залишаються активними.
 *
 * НЕ вмикати на qa/prod - це вимикає реальний захист від підпису чужим
 * ключем.
 */
export const SKIP_KEY_CODE_VALIDATION = false;
